export class MedicamentoRecebidos {
    coDispensacao?: number;
    municipio?: string;
    id?: number;
    nome?: string;
    nomeUnidadeDispensacao?: string;
    tpDispensacao?: string;
    ufRetirada?: string;
    vlCidadao?: string;
    vlMinstSaude?: string;
    vlTotal?: string;
    qtdDispensada?: number;
    avaliacao?: any;
    data?: string;

    constructor(data?) {
        if (data) {
            this.coDispensacao = data.coDispensacao;
            this.municipio = data.municipio;
            this.id = data.id;
            this.nome = data.nomeMedicamento;
            this.nomeUnidadeDispensacao = data.nomeUnidadeDispensacao;
            this.tpDispensacao = data.tpDispensacao;
            this.ufRetirada = data.ufRetirada;
            this.vlCidadao = data.vlCidadao;
            this.vlMinstSaude = data.vlMinstSaude;
            this.vlTotal = data.vlTotal;
            this.qtdDispensada = data.qtdDispensada;
            this.avaliacao = data.avaliacao;
            //this.avaliacao = null;
            this.data = data.dataRetirada;
        }
    }

    public static fromDTO?(data) {
        const medicamento = new MedicamentoRecebidos();
        medicamento.coDispensacao = data.coDispensacao;
        medicamento.nome = data.nome;
        medicamento.municipio = data.municipio;
        medicamento.id = data.id;
        medicamento.tpDispensacao = data.tpDispensacao;
        medicamento.ufRetirada = data.ufRetirada;
        medicamento.vlCidadao = data.vlCidadao;
        medicamento.vlMinstSaude = data.vlMinstSaude;
        medicamento.vlTotal = data.vlTotal;
        medicamento.qtdDispensada = data.qtdDispensada;
        medicamento.avaliacao = data.avaliacao;
        medicamento.data = data.data;
        return medicamento;
    }

    public toDTO?() {
        const dto: any = {};
        dto.nome = this.nome;
        dto.municipio = this.municipio;
        dto.id = this.id;
        dto.tpDispensacao = this.tpDispensacao;
        dto.ufRetirada = this.ufRetirada;
        dto.vlCidadao = this.vlCidadao;
        dto.vlMinstSaude = this.vlMinstSaude;
        dto.vlTotal = this.vlTotal;
        dto.qtdDispensada = this.qtdDispensada;
        dto.coDispensacao = this.coDispensacao;
        dto.avaliacao = this.avaliacao;
        dto.data = this.data;
        return dto;
    }

}
